import {Component} from 'react';
import { doubleToStringMonthly, standardNumberFormat } from '../../../objects/CommonUse/double_functions';
import { reformatDateToDisplay } from '../../../objects/CommonUse/reformatDateToDisplay_function';


class InvestmentTransactionCard extends Component {
    constructor(props) {
        super(props);
        this.state = {open: false, 
             selected: false,
           
        };
        this.computeProfitLoss();
    }

    computeProfitLoss(){
        this.profitLoss = this.props.transInfo.totalCurrentPrice -  this.props.transInfo.totalInitialPrice;
        this.profitLossClass = "text-center";
        if (this.profitLoss < 0){
            this.profitLossClass += " text-danger";
        }
    }
          
    render() {
    return <>
        <tr>
            {this.props.summaryPage === true   ?
                <th className="text-left">{this.props.transInfo.investmentName}</th>
            :
                null
            }
            {this.props.investType === "bond"  ?
                <th className="text-left">{this.props.transInfo.classification}</th>
            :
                null
            }
            {this.props.summaryPage === true  ?
                <td className="text-center">{this.props.transInfo.symbol}</td>
            :
                null
             }
             {this.props.summaryPage === true ?
                null
             :
                <td className="text-center">{reformatDateToDisplay(this.props.transInfo.transactionDate)}</td>
             }
            <td className="text-center">{standardNumberFormat(this.props.transInfo.quantity)}</td>
            {this.props.summaryPage === true  ?
                null
            :
                <td className="text-center">{doubleToStringMonthly(this.props.transInfo.initialPrice)}</td>
            }
            <td className="text-center">{doubleToStringMonthly(this.props.transInfo.totalInitialPrice)}</td>
            {this.props.summaryPage === true  ?
                null
            :
                <td className="text-center">{doubleToStringMonthly(this.props.transInfo.currentPrice)}</td>
            }
            <td className="text-center">{doubleToStringMonthly(this.props.transInfo.totalCurrentPrice)}</td>
            <td className={this.profitLossClass}>{doubleToStringMonthly(this.profitLoss)}</td>
        </tr>
          
    </>
    }



}

export default InvestmentTransactionCard;